import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Sobre from '../components/Sobre';
import Servicos from '../components/Servicos';
import SubHero from '../components/SubHero';
import Depoimentos from '../components/Depoimentos';
import Faq from '../components/Faq';
import Contato from '../components/Contato';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SubHero />
        <Sobre />
        <Servicos />
        <Depoimentos />
        <Faq />
        <Contato />
      </main>
    </>
  );
}
